import { Pending } from "@mui/icons-material";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Box, Typography } from "@mui/material";
import { JSX } from "react";

export type InstallmentStatus = "PENDING" | "APPROVED" | "REJECTED";

export interface InstallmentApplication {
  applicationId: string;
  installmentId: string;
  installmentStatus: InstallmentStatus;
  capitalAmount: number;
  interestAmount: number;
  rejectReason: string;
  url: string;
  createdAt: string;
  updatedAt: string;
}

export function getInstallmentStatusLabel(status: string): JSX.Element {
  switch (status) {
    case "PENDING":
      return (
        <Box display="flex" alignItems="center" gap={0.5}>
          <Pending fontSize="small" sx={{ color: "orange" }} />
          <Typography variant="body2">Pendiente</Typography>
        </Box>
      );
    case "APPROVED":
      return (
        <Box display="flex" alignItems="center" gap={0.5}>
          <CheckCircleIcon fontSize="small" sx={{ color: "green" }} />
          <Typography variant="body2">Aprobado</Typography>
        </Box>
      );
    case "REJECTED":
      return (
        <Box display="flex" alignItems="center" gap={0.5}>
          <CancelIcon fontSize="small" sx={{ color: "red" }} />
          <Typography variant="body2">Rechazado</Typography>
        </Box>
      );
    default:
      return (
        <Box display="flex" alignItems="center" gap={0.5}>
          <Typography variant="body2">{status}</Typography>
        </Box>
      );
  }
}

export function calculateMonthlyInstallment(
  amount: number,
  interestRate: number,
  termMonths: number
): number {
  const monthlyInterest = amount * (interestRate / 100);
  const capitalPart = amount / termMonths;
  const cuota = capitalPart + monthlyInterest;
  return Math.round(cuota);
}
